<template>
  <section>
    <v-menu v-model:opened="menu" location="left top">
      <template #activator="{ props }">
        <v-btn
          class="mb-2"
          block
          size="small"
          variant="outlined"
          v-bind="props"
          @click="menu = !menu"
          data-testid="yard-drop-hook-button">
          {{ t('yard.common.phrases.linkAppointment') }}
          <v-icon>{{ menu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </template>
      <v-list class="py-4">
        <v-list-item
          data-testid="yard-link-appointment-create-button"
          class="clickable"
          @click="$emit('open-create-appointment-dialog')">
          <v-list-item-title>
            <v-icon size="small" class="mr-1">mdi-calendar</v-icon>
            {{ t('yard.common.phrases.createAppointment') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="yard-link-appointment-link-button"
          class="clickable"
          @click="$emit('open-link-appointment-dialog')">
          <v-list-item-title>
            <v-icon size="small" class="mr-1">mdi-link</v-icon>
            {{ t('yard.common.phrases.linkToAppointment') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </section>
</template>
<script>
import { defineComponent, ref } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewLinkAppointmentButton',
  emits: ['open-create-appointment-dialog', 'open-link-appointment-dialog'],
  props: {
    assetVisit: {
      type: Object,
      required: true
    }
  },
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const menu = ref(false);

    return {
      t,
      menu,
      getSpotIcon: yardStore.getSpotIcon,
      getSpotStatus: yardStore.getSpotStatus,
      isSpotClosed: yardStore.isSpotClosed,
      isSpotOpen: yardStore.isSpotOpen
    };
  }
});
</script>
